import React from 'react'
import { useRecoilValue } from 'recoil'
import { loveInterestAtom } from '../../../../state/assessment'

export default function Index(props) {
  const loveInterestObj = useRecoilValue(loveInterestAtom);
  
  // Handle both string and object cases, with fallback to default
  let loveInterest;
  if (loveInterestObj && typeof loveInterestObj === 'object' && loveInterestObj.loveInterest) {
    loveInterest = loveInterestObj.loveInterest;
  } else if (loveInterestObj && typeof loveInterestObj === 'string') {
    loveInterest = loveInterestObj;
  } else {
    // Fallback to default if neither case works
    loveInterest = null; // Don't show any name if not set
  }
  
  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Directions
        </div>
        <div className="assessment1-content">
          As an experienced waiter, you understand that the guests being back at their table and conversing presents a chance to learn more about them, particularly your love interest, {loveInterest || '[Love interest name]'}. However, the restaurant's noise level makes it challenging to hear every word of their conversation. Utilize your verbal reasoning skills to fill in each blank with the word that logically fits based on the context.
        </div>

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
